import React from "react";
import { useTranslation } from "react-i18next";
import "./education.css";
import LaptopIcon from "assets/images/laptop-icon.png";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import UNSWLogo from "assets/images/unsw-logo.png";
import Header from "components/Header";
import Footer from "components/Footer";

const Education = () => {
  const { t } = useTranslation();

  return (
    <div>
      <Header />
      <div className="education">
        <div className="education-history">
          <img src={UNSWLogo} />
          <h1>{t("education.masters.title")}</h1>
          <h2>{t("education.masters.school")}</h2>
          <h3>{t("education.masters.date")}</h3>
          <p>{t("education.masters.paragraph1")}</p>
          <p>{t("education.masters.paragraph2")}</p>
        </div>

        <div className="education-history">
          <img src={UNSWLogo} />
          <h1>{t("education.bachelor.title")}</h1>
          <h2>{t("education.bachelor.school")}</h2>
          <h3>{t("education.bachelor.date")}</h3>
          <p>{t("education.bachelor.paragraph1")}</p>
          <p>{t("education.bachelor.paragraph2")}</p>
          <br />
          <p>{t("education.bachelor.relevantSubjects")}</p>
          {/* <div className="relevant-subject"> */}
          <div className="relevant-subject">
            <ul>
              {t("education.bachelor.subjectsColumn1", {
                returnObjects: true,
              }).map((subject, index) => (
                <li key={index}>{subject}</li>
              ))}
            </ul>
          </div>
          <div className="relevant-subject">
            <ul>
              {t("education.bachelor.subjectsColumn2", {
                returnObjects: true,
              }).map((subject, index) => (
                <li key={index}>{subject}</li>
              ))}
            </ul>
          </div>
        </div>
        {/* </div> */}
      </div>
      <Footer />
    </div>
  );
};

export default Education;
